module.exports = __webpack_public_path__ + "static/img/xwq_01.18fffb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xwq_01.png
// module id = oUGp
// module chunks = 0